import React from 'react';

import {
  Select,
  MenuItem,
  SelectChangeEvent,
  OutlinedInput,
  Typography,
} from '@mui/material';

import { ReactComponent as DownIcon } from '../../../../common/assets/icons/chevron_down_icon.svg';
import './SharedButtons.scss';

type Props = {
  value: 10 | 15 | 25 | 10000;
  onChange: (amount: 10 | 15 | 25 | 10000) => void;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  disableScrollLock: true,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const RESULTS = [
  {
    label: 'Show 10 results',
    amount: 10,
  },
  {
    label: 'Show 15 results',
    amount: 15,
  },
  {
    label: 'Show 25 results',
    amount: 25,
  },
  {
    label: 'Show all results',
    amount: 10000,
  },
];

const getOptionByValue = (amount: number) => {
  if (amount === 10) return RESULTS[0];
  if (amount === 15) return RESULTS[1];
  if (amount === 25) return RESULTS[2];
  return RESULTS[3];
};

const SelectNumberOfResultsButton: React.FC<Props> = ({ value, onChange }) => {
  const [selectedLimit, setSelectedLimit] = React.useState<{
    label: string;
    amount: number;
  }>(getOptionByValue(value));

  React.useEffect(() => {
    if (value) setSelectedLimit(getOptionByValue(value));
  }, [value]);

  const handleChange = (event: SelectChangeEvent<typeof selectedLimit>) => {
    const {
      target: { value },
    } = event;

    if (value && typeof value === 'object') {
      onChange(value.amount as 10 | 15 | 25 | 10000);
    }
  };

  return (
    <Select
      color='secondary'
      displayEmpty
      value={selectedLimit}
      onChange={handleChange}
      input={
        <OutlinedInput
          className='select-number-results-input'
          sx={{
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: '#00214580',
            },
            borderRadius: '50px',
          }}
        />
      }
      renderValue={(selected) => {
        if (!!!selected) {
          return (
            <Typography color={'secondary'}>{RESULTS[0].label}</Typography>
          );
        }
        return <Typography color={'secondary'}>{selected.label}</Typography>;
      }}
      IconComponent={() => <DownIcon style={{ flexShrink: 0 }} />}
      MenuProps={MenuProps}
    >
      {RESULTS.map((result) => (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <MenuItem key={result.label} value={result as any}>
          <Typography>{result.label}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectNumberOfResultsButton;
